import React from 'react'
import './App.css?ver=2107191848';

import 'rsuite/dist/styles/rsuite-default.css';
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Header from './components/header'
import Footer from './components/footer'
import PageHome from './components/page-home'
import PageProducts from './components/page-products'
import PageSingleProduct from './components/page-product' 
import PageContact from './components/page-contact'
import NotForIE from './components/not-for-ie'

import { useTranslation } from 'react-i18next'

import * as scripts from './scripts/scripts' 
  
const App = () => {

  const languages = ['pl','en','ru','ro']

  const itIsMSIE = scripts.msieversion()

  const { i18n } = useTranslation()
  const lang = i18n.language

  if (!languages.includes(lang)) {
    i18n.changeLanguage('pl')
  }


  return (
    <Router>
      <div>
        <Header />
        <section className="section container">
          { itIsMSIE === false ? (
            <>
              <Route exact path="/" component={PageHome}/>
              <Route path="/products" component={PageProducts}/> 
              <Route path="/product/:id" component={PageSingleProduct}/>
              <Route path="/contact" component={PageContact}/>
            </>
          ) : (
            <NotForIE/>
          ) }
        </section>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
